import React from "react";

interface SingleBarProps {
  firstValue: number;
  secondValue: number;
  firstColor: string;
  secondColor: string;
}

const SingleBar: React.FC<SingleBarProps> = ({
  firstValue,
  secondValue,
  firstColor,
  secondColor,
}) => {
  const firstWidth = (firstValue || 0) * 100;
  const secondWidth = (secondValue || 0) * 100;
  const isFirstOnly = firstValue === 1 && secondValue === 0;
  const isSecondOnly = secondValue === 1 && firstValue === 0;

  return (
    <div className="flex h-[30px] w-full relative">
      <div
        className={`h-full flex items-center justify-center ${
          isFirstOnly ? "rounded-lg" : "rounded-l-lg"
        }`}
        style={{ width: `${firstWidth}%`, backgroundColor: firstColor }}
      >
        {firstValue > 0 && (
          <span className="text-white text-sm font-semibold">
            {Math.round(firstValue * 100)}%
          </span>
        )}
      </div>
      <div
        className={`h-full flex items-center justify-center ${
          isSecondOnly ? "rounded-lg" : "rounded-r-lg"
        }`}
        style={{ width: `${secondWidth}%`, backgroundColor: secondColor }}
      >
        {secondValue > 0 && (
          <span className="text-white text-sm font-semibold">
            {Math.round(secondValue * 100)}%
          </span>
        )}
      </div>
    </div>
  );
};

export default SingleBar;
